import {cardTitle} from "assets/jss/material-dashboard-pro-react.jsx";
import buttonStyle from "assets/jss/material-dashboard-pro-react/components/buttonStyle.jsx";
import {specialScrollbar} from "assets/jss/special-scrollbar.jsx";
import customCheckboxRadioSwitch from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx";
import customSelectStyle from "../customSelectStyle";

const userProfileStyles = {
  ...customCheckboxRadioSwitch,
  ...customSelectStyle,
  cardTitle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "10px",
    marginBottom: "10px",
    "& small": {
      fontSize: "80%",
      fontWeight: "400"
    }
  },
  cardCategory: {
    marginTop: "10px",
    color: "#999999 !important",
    textAlign: "center"
  },
  description: {
    color: "#999999"
  },
  updateProfileButton: {
    float: "right"
  },
  mapButton: {
    backgroundColor: "#dadada",
    color: "#1b1b1b",
    padding: "9px",
    float: "right"
  },
  profileContainer: {
    "&> div > div > h2": {
      padding: "0",
      margin: "0"
    }
  },
  modalCardTitle: {
    fontSize: "23px",
    position: "relative",
    top: "5px",
    left: "10px"
  },
  buttonConfirm: {
    width: "150px"
  },
  ...buttonStyle,
  progressoStep: {
    margin: "10px -20px",
    padding: "3px 20px",
    "&>h4": {
      textAlign: "center"
    },
    "&:nth-child(2n)": {
      backgroundColor: "#fafafa",
    }
  },
  progressoFases: {
    textAlign: "center",
    display: "flex",
    marginRight: 30
  },
  progressoFase: {
    width: "25%",
    display: "flex",
    padding: "10px 0",
    paddingLeft: 30,
    minWidth: "fit-content",
    minHeight: "70px",
    borderLeft: "none",
    flex: 1,
    flexDirection: "column",
    justifyContent: "center",
    position: "relative",
    "&:after": {
      content: `""`,
      borderStyle: "solid",
      borderWidth: "34px 0 35px 30px",
      position: "absolute",
      right: -29,
      top: 0
    },
    "&:first-child": {
      zIndex: "10",
      paddingLeft: 0
    },
    "&:nth-child(2)": {
      zIndex: "9",
    },
    "&:nth-child(3)": {
      zIndex: "8",
    },
    "&:nth-child(4)": {
      zIndex: "7",
    },
    "&:last-child": {
      paddingLeft: "35px"
    },
    "&.feito": {
      color: "white",
      background: "linear-gradient(to right, #38B449 0%, #009344 100%);",
      "&:after": {
        borderColor: "transparent transparent transparent #009344",
      }
    },
    "&.nao_feito": {
      background: "linear-gradient(to right, #fafafa 0%,#dfdfdf 100%);",
      "&:after": {
        borderColor: "transparent transparent transparent #dfdfdf",
      }
    },
    "&.em_progresso": {
      color: "white",
      background: "linear-gradient(to right, #00acc1 0%, #0099ab 100%);",
      "&:after": {
        borderColor: "transparent transparent transparent #0099ab",
      }
    }
  },
  faseDesignacao: {
    whiteSpace: "nowrap"
  },
  faseSubtitulo: {
    display: "block",
    opacity: "0.8",
    "&:empty": {
      display: "none"
    }
  },
  progressoSingleStepBox: {
    textAlign: "center",
    height: "78px",
    lineHeight: "78px",
    borderRadius: "10px",
    width: "80px",
    marginLeft: "calc(50% - 40px)",
    color: "white",
    "&.feito": {
      background: "linear-gradient(to right, #38B449 0%, #009344 100%);",
    },
    "&.nao_feito": {
      background: "linear-gradient(to right, #fafafa 0%,#dfdfdf 100%);",
    },
    "&.em_progresso": {
      background: "linear-gradient(to right, #00acc1 0%, #0099ab 100%);",
    }
  },
  stepEmFalta: {
    margin: "15px"
  },
  emFaltaCheckbox: {
    color: "rgba(0,0,0,0)",
    width: "23px",
    paddingLeft: "3.5px",
    margin: "10px",
    display: "inline-block",
    "&.feito": {
      color: "#2cc128"
    },
    "&.em_progresso": {
      color: "#1cacbf"
    },
    "&.nao_feito": {
      color: "lightgray"
    }
  },
  placeholderMap: {
    height: "330px",
    backgroundPosition: "center",
    backgroundSize: "cover",
    borderRadius: "10px"
  },
  formacaoPostWrapper: {
    overflow: "auto",
    maxHeight: "350px",
    ...specialScrollbar
  },
  formacaoPost: {
    display: "block",
    marginRight: 5,
    "&:not(:last-child)": {
      paddingBottom: "6px",
      borderBottom: "1px solid #d8d8d8"
    }
  },
  formacaoPostData: {
    display: "block",
    textAlign: "right"
  },
  formandoEstadoAprovado: {
    padding: "4px 10px",
    fontSize: "12px",
    borderRadius: "4px",
    backgroundColor: "#30af48",
    color: "white"
  },
  formandoEstadoReprovado: {
    padding: "4px 10px",
    fontSize: "12px",
    borderRadius: "4px",
    backgroundColor: "#af2a32",
    color: "white"
  },
  formandoEstadoPorAvaliarFrequentar: {
    padding: "4px 10px",
    fontSize: "12px",
    borderRadius: "4px",
    backgroundColor: "grey",
    color: "white"
  },
  formandoEstadoPorFrequentar: {
    padding: "4px 10px",
    borderRadius: "4px",
    fontSize: "12px",
    backgroundColor: "grey",
    color: "white"
  },
  formandoEstadoInscricaoAprovar: {
    padding: "4px 10px",
    borderRadius: "4px",
    fontSize: "12px",
    backgroundColor: "grey",
    color: "white"
  },
  formandoEstadoDarFeedback: {
    padding: "4px 10px",
    fontSize: "12px",
    borderRadius: "4px",
    backgroundColor: "#00acc1",
    color: "white"
  },
  placeHolderContainer: {
    textAlign: "center",
    marginTop: 100
  },
  placeHolderImg: {
    width: "240px",
    display: "block",
    margin: "auto",
    marginTop: "80px"
  },
  userNIN: {
    fontWeight: "bold",
    fontSize: "11px",
    color: "#a5a5a5"
  },
  cardEvent: {
    paddingTop: "8px",
    paddingBottom: "7px",
    width: "100%!important",
    margin: "0",
    borderBottom: "1px solid #ececec"
  },
  cardEventDate: {
    display: "block",
    fontSize: "12px"
  },
  cardEventTitle: {
    display: "block",
    fontWeight: "400",
  },
  cardEventType: {
    display: "block",
    fontWeight: "400",
    fontStyle: "italic"
  },
  cardPostDate: {
    display: "block",
    fontSize: "12px"
  },
  cardPostModule: {
    display: "inline-block",
    //padding: "0 6px",
    fontSize: 12,
    //background: "#f0f0f0",
    //borderRadius: 6
    borderBottom: "solid 1px grey",
    marginBottom: 6,
    lineHeight: 1.1,
    paddingRight: 4,
    marginRight: 10
  },
  cardPostTitle: {
    display: "block",
    fontWeight: "400"
  },
  cardPostContent: {
    display: "block",
    fontWeight: "300"
  },
  cardFormacaoContinua: {
    textAlign: "center",
    height: "100%",
    marginTop: 0,
    marginBottom: 0,
    "& span": {
      color: "gray"
    },
    "& h4": {
      fontWeight: "400",
      lineHeight: "1",
      fontSize: "1.5em",
      margin: "auto"
    },
    "& > div": {
      display: "flex",
      flexDirection: "column"
    }
  },
  semCursosDisponiveis: {
    display: "block",
    textAlign: "center",
    padding: "10px 0",
    "& span": {
      color: "gray"
    }
  },
  percursosAccordionPanel: {
    backgroundColor: "white",
    borderLeft: "4px solid #009344",
    boxShadow: "0 3px 10px -6px #0000000d",
    borderRadius: 0,
    borderBottom: "none",
    paddingLeft: 10,
    "& .MuiExpansionPanelSummary-content": {
      alignItems: "center"
    }
  },
  percursosAccordionExpansionPanel: {
    borderBottom: "1px solid #ececec",
    "& .MuiCollapse-wrapper": {
      borderTop: "1px solid #ececec"
    }
  },
  tabelaPagamentos: {
    borderCollapse: "collapse",
    marginTop: 4,
    "& td": {
      borderBottom: "1px solid #ececec",
      padding: 12,
      fontSize: 12
    }
  },
  tarefasRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px 0",
    "& p": {
      margin: 0
    },
    "& button": {
      margin: "-1px 10px",
      paddingTop: "4px!important"
    },
    "&:not(:last-child)": {
      borderBottom: "solid #f2f2f2 1px"
    }
  },
  tarefasInstrucoes: {
    marginBottom: 10,
    fontWeight: 400
  },
  checkAprovar: {
    width: "80%"
  },
  codigoCurso: {
    color: "gray",
    minWidth: 115,
    display: "block",
    marginTop: -10,
    fontSize: 14
  },
  submissaoLista: {
    padding: "10px 15px",
    borderBottom: "1px solid #eee",
    cursor: "pointer",
    display: "block",
    "&.visto": {
      opacity: 0.85
    },
    "&:first-child": {
      borderRadius: "6px 6px 0 0",
    },
    "&:last-child": {
      marginBottom: "10px"
    },
    "&:hover": {
      backgroundColor: "#f9f9f9",
      opacity: 1
    },
    "&:active,&.active": {
      backgroundColor: "whitesmoke",
      opacity: 1
    },
    "& .subject": {
      fontSize: "16px",
      fontWeight: "400",
      width: "calc(100% - 15px)",
      display: "inline-block",
      marginRight: 0
    },
    "& .bottom": {
      marginBottom: 0
    },
    "& .top": {
      position: "relative",
      marginBottom: 0,
      "&>svg": {
        position: "absolute",
        top: "2px",
        right: "0",
        width: "0.7em!important",
        color: "#2AAEF5"
      }
    },
    "& .date": {
      color: "gray"
    },
  },
};
export default userProfileStyles;
